<template>
  <div class="position-relative d-flex">
    <!-- 문서 리스트 -->
    <div class="w-100">
      <b-row
        v-for="(doc, index) in disclosure_group.documents"
        :key="index"
        class="d-flex justify-content-between align-items-center document-item py-3 border-bottom"
      >
        <b-col cols="12" sm="8" xl="9">
          <h5
            class="fw-600 mb-0 text-left gray-850"
            :style="{
              borderLeft: '4px solid ' + selected_report.main_color,
              paddingLeft: '10px'
            }"
            @click="
              doc.description != null &&
                doc.description !== 'null' &&
                doc.description !== 'undefined' &&
                selectDoc(index)
            "
          >
            {{ lang === 'KOR' ? doc.title : doc.translated?.title_e || doc.title }}
          </h5>
        </b-col>
        <b-col
          cols="12"
          sm="4"
          xl="3"
          class="d-flex justify-content-start justify-content-sm-end align-items-start mt-3 mt-sm-0"
        >
          <div>
            <!-- type=file: 다운로드 (기존 동작) -->
            <a
              v-if="doc.type === 'file'"
              class="cursor btn-skep mr-2"
              :href="print_mode ? $store.state.static_host + doc.file_url : '#'"
              target="_blank"
              @click.prevent="
                doc.file_url && downloadFile(doc.title, $store.state.static_host + doc.file_url)
              "
            >
              {{ lang === 'KOR' ? '다운로드' : 'Download' }}
              <b-icon icon="download" />
            </a>
            <!-- type=link: 외부 링크는 새 탭. safeHref로 javascript:/data: 등 위험 스킴 차단 -->
            <a
              v-else-if="doc.type === 'link'"
              class="cursor btn-skep mr-2"
              :href="safeHref(doc.link)"
              target="_blank"
              rel="noopener noreferrer"
            >
              {{ lang === 'KOR' ? '바로가기' : 'Open' }}
              <b-icon icon="box-arrow-up-right" />
            </a>
            <!-- type=storyboard: 보고서 내부 링크는 같은 탭에서 이동 -->
            <a
              v-else-if="doc.type === 'storyboard'"
              class="cursor btn-skep mr-2"
              :href="safeHref(doc.link)"
            >
              {{ lang === 'KOR' ? '바로가기' : 'Open' }}
              <b-icon icon="box-arrow-up-right" />
            </a>
          </div>
        </b-col>

        <!-- 클릭된 문서 설명을 제목 아래에 절대 위치로 -->
        <div v-if="selectedDocIndex === index" class="doc-desc">
          <div
            v-image-modal
            v-html="
              sanitizeHtml(lang === 'KOR' ? doc?.description : doc?.translated?.description_e)
            "
          ></div>
        </div>
      </b-row>
    </div>
  </div>
</template>

<script>
import { downloadFile } from '@/components/util.js';
import { mapState, mapGetters } from 'vuex';
import { sanitizeHtml } from '@/components/sanitize.js';

export default {
  name: 'DocumentSetSb',
  props: {
    disclosure_group: {
      type: Object,
      required: true
    },
    print_mode: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      selectedDocIndex: null
    };
  },
  computed: {
    ...mapGetters('report_list', ['selected_report']),
    ...mapState('report_list', ['lang'])
  },
  methods: {
    sanitizeHtml,
    downloadFile,
    selectDoc(index) {
      // 이미 선택된 인덱스면 null로, 아니면 해당 인덱스로 토글
      this.selectedDocIndex = this.selectedDocIndex === index ? null : index;
    },
    // #845 공개 뷰어에서 link/storyboard href에 javascript: 등 위험 스킴이 들어오지 않도록 화이트리스트 검증
    safeHref(link) {
      if (!link || typeof link !== 'string') return '#';
      const trimmed = link.trim();
      if (/^(https?:|\/|#)/i.test(trimmed)) return trimmed;
      return '#';
    }
  }
};
</script>

<style scoped>
.title-wrap {
  white-space: normal;
  word-wrap: break-word;
  word-break: break-word;
}

/* h5 호버 효과 */
.document-item h5:hover {
  background-color: #f5f5f5;
  cursor: pointer;
}

/* 각 아이템을 기준으로 절대 배치되도록 */
.document-item {
  position: relative;
}

/* 설명 박스 */
.doc-desc {
  position: absolute;
  top: 105%;
  /* 제목/아이템 바로 아래 */
  left: 0;
  width: 100%;
  background: #fff;
  padding: 16px;
  border: 1px solid #ccc;
  border-radius: 12px;
  z-index: 10;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
</style>
